import clsx from 'clsx';
import React from 'react';
export const InputDateCalendarIcon = props => {
  const {
    error,
    disabled,
    onlyTime
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: clsx('mdi cursor-pointer font-size-20', onlyTime ? 'mdi-clock' : 'mdi-calendar', {
      'text-primary': !error && !disabled,
      'text-danger': error,
      'text-muted': disabled
    })
  }));
};